/**
 * Routine Slider - Expandable Description Toggle
 * Handles click interactions for routine slider buttons with expandable text
 */

class RoutineSlider {
  constructor() {
    this.init();
  }

  init() {
    // Find all routine slider buttons
    const buttons = document.querySelectorAll('[data-routine-toggle]');

    buttons.forEach(button => {
      button.addEventListener('click', (e) => this.handleToggle(e));
    });
  }

  handleToggle(event) {
    const button = event.currentTarget;
    const description = button.querySelector('[data-routine-description]');

    // If no description, do nothing
    if (!description) return;

    // Get current state
    const isExpanded = button.getAttribute('aria-expanded') === 'true';

    // Toggle state
    const newState = !isExpanded;
    button.setAttribute('aria-expanded', newState);

    // Toggle description visibility with animation
    if (newState) {
      description.classList.add('is-expanded');
    } else {
      description.classList.remove('is-expanded');
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new RoutineSlider();
  });
} else {
  new RoutineSlider();
}

// Reinitialize for Shopify theme editor
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    new RoutineSlider();
  });
}
